export interface IChartDataset<T> {
    legend: string;
    xaxis: T[];
    yaxis: number[];
    images?: IChartImage<T>[];
    customdata?: any[];
    backgroundColor?: string;
    borderColor?: string;
    stepped?: string | boolean;
}

export interface IChartImage<T> {
    src: string;
    xaxis: T;
    yaxis: number;
}

export class ChartDataset<T> implements IChartDataset<T> {
    legend: string;
    xaxis: T[];
    yaxis: number[];
    backgroundColor?: string;
    borderColor?: string;
    stepped?: string | boolean;
    images?: IChartImage<T>[];
    customdata?: any[];

    public constructor(item: ChartDataset<T>) {
        this.legend = item.legend;
        this.xaxis = item.xaxis;
        this.yaxis = item.yaxis;
        this.images = item.images ?? [];
        this.customdata = item.customdata ?? [];
        this.backgroundColor = item.backgroundColor;
        this.borderColor = item.borderColor;
        this.stepped = item.stepped;
    }
}
